module.exports = "mutation CreateManualShipping($shipping:CreateManualShippingInput!){createManualShipping(shipping:$shipping){success shippingId}}"